import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as orderActions from './../../../../../actions/orderAction';
import OrderAccessTrade from './OrderAccessTrade';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        exportAccessTrade: (params) => dispatch(orderActions.exportAccessTrade(params)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderAccessTrade));
